import { h, Component } from 'preact';
import { Loader } from 'rendering/components/loader';
import { COMPOSITIONS, COMPOSITION_TYPES, ALL_STYLES } from 'constants/annotations';

export class QuizAnnotation extends Component {
    constructor(...args) {
        super(...args);
        this.loadAnnotation();
    }
    
    render() {
        const { props } = this;
        const { loaded = false, QuizAnnotation } = this.state;

        return (
            loaded ?
                <QuizAnnotation {...props} /> :
                <div style={this.loaderStyles}>
                    <Loader />
                </div>
        )
    }

    loadAnnotation() {
        import(
            /* webpackChunkName: "quiz-annotation" */ 
            './quiz'
        )
        .then(({QuizAnnotation}) => {
            this.setState({
                loaded: true,
                QuizAnnotation
            });
        })
    }

    get loaderStyles() {
        const { styles = {} } = this.props;        
        return {
            ...(styles['compositionTypes.root'] || {}),
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }
    }

    static get composition() {
        return [
            { ...COMPOSITIONS.SIMPLE },
            ...Object
                .values(COMPOSITION_TYPES.QUIZ)
                .map(v => ({
                    IDENTIFIER: v,
                    STYLES: ALL_STYLES
                }))
        ];
    }

    static get schemaType () {
        return 'quiz';
    }
}

export class AdjacentQuizAnnotation extends QuizAnnotation {
    static scalable = true

    loadAnnotation() {
        import(
            /* webpackChunkName: "adjacent-quiz-annotation" */ 
            './adjacent'
        )
        .then(({AdjacentQuizAnnotation}) => {
            this.setState({
                loaded: true,
                QuizAnnotation: AdjacentQuizAnnotation
            });
        })
    }
}